import { render, staticRenderFns } from "./NetDetail.vue?vue&type=template&id=b06cdfd4"
import script from "./NetDetail.vue?vue&type=script&lang=js"
export * from "./NetDetail.vue?vue&type=script&lang=js"
import style0 from "./NetDetail.vue?vue&type=style&index=0&id=b06cdfd4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NetDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports